// extracted by mini-css-extract-plugin
module.exports = {"graphsHeader":"GraphsHeader_graphsHeader__Vysd-","header":"GraphsHeader_header__1vbkA","title":"GraphsHeader_title__15y7v","highTitle":"GraphsHeader_highTitle__33f9N"};